module.exports = "https://cdn.dove.it/_next/static/public/assets/services/notaio_430.173ff15d48fe854ee48110b185f7fb36.jpg";